//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
  name: 'feedbackForm',
  data() {
    return {
      terms: false,
      choice: 'nee',
      filter: {
        form: 'feedback',
        from_email: '',
        reply_to_user: true,
        return_url: '/bedankt',
        content: {
          name: '',
          email: '',
          subject: 'Feedback',
          device: '',
          rating: 0,
          feedback: '',
          browser: '',
          missing: '',
          wrong: 'nee',
          textwrong: ' ',
        },
      },
    }
  },
  computed: {
    ...mapState({
      formStatus: ({ formStore: {formStatus} }) => formStatus,
    }),
  },
  methods: {
    processForm: function() {
      var error = {};
      if (!this.filter.content.name) {
        error.type = 'name';
        error.text = 'Je hebt je naam niet ingevuld';
        this.$store.commit('formStore/updateErrors', error);
      } else {
        this.filter.from_name = this.filter.content.name;
      }

      if (!this.filter.content.email) {
        error.type = 'email';
        error.text = 'Je emailadres is ongeldig';
        this.$store.commit('formStore/updateErrors', error);
      } else {
        this.filter.from_email = this.filter.content.email;
      }

      if (!this.filter.content.feedback) {
        error.type = 'feedback';
        error.text = 'We willen graag weten waarom je deze beoordeling geeft';
        this.$store.commit('formStore/updateErrors', error);
      }
      if (!this.filter.content.missing) {
        error.type = 'missing';
        error.text = 'We willen graag weten of je iets mist';
        this.$store.commit('formStore/updateErrors', error);
      }
      if (this.filter.content.wrong == 'ja' && !this.filter.content.textwrong) {
        error.type = 'textwrong';
        error.text = 'We willen graag weten wat er mis gaat. Gaat alles goed? Verander dan je keuze naar nee.';
        this.$store.commit('formStore/updateErrors', error);
      }
      if (this.filter.content.wrong == 'ja' && !this.filter.content.browser) {
        error.type = 'browser';
        error.text = 'We willen graag weten welke browser je gebruikt';
        this.$store.commit('formStore/updateErrors', error);
      }
      if (this.filter.content.wrong == 'ja' && !this.filter.content.device) {
        error.type = 'device';
        error.text = 'We willen graag weten wat voor apparaat je gebruikt.';
        this.$store.commit('formStore/updateErrors', error);
      }

      if (!this.terms) {
        error.type = 'terms';
        error.text = 'Je moet akkoord gaan met de algemene voorwaarden en de geldende privacy verklaring';
        this.$store.commit('formStore/updateErrors', error);
      }

      let form = document.getElementById('feedback');
      var formData = new FormData(form);
      formData.append('form', this.filter.form); 
      formData.append('from_email', this.filter.from_email); 
      formData.append('from_name', this.filter.from_name); 
      formData.append('subject', this.filter.content.subject); 
      formData.append('device', this.filter.content.device); 
      formData.append('reply_to_user', this.filter.reply_to_user); 
      formData.append('return_url', this.filter.return_url); 
      formData.delete('terms'); 

      if (Object.keys(this.formStatus.errors).length === 0) {
        this.$store.dispatch('formStore/sendForm', formData);
      } else {
        this.goto('feedback');
        var notificationObj = {};
        notificationObj.type = 'error';
        notificationObj.message = 'Je formulier is niet verzonden. Vul ook de rood gekleurde velden in.';
        this.$store.commit('notificationStore/setNotification', notificationObj);  
        this.$forceUpdate();
      }
    },
  }
}
